import {
  Avatar,
  Badge,
  Breadcrumb,
  Button,
  Col,
  Empty,
  Flex,
  Form,
  Modal,
  Popover,
  Row,
  Skeleton,
  Table,
  TreeSelect,
  Typography,
  message,
} from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { NavLink, useParams } from "react-router-dom";
import { transformData } from "../../../../utils/recursive";
import { resolveImageUrl } from "../../../../utils/image";
import {
  exchangePoint,
  getPointCustomerSee,
} from "../../../../api/customerSee/customerSee";
import { calculateTimeDifference } from "../../../../utils/dateTime";
import { GiftOutlined, SearchOutlined, SwapOutlined } from "@ant-design/icons";
import { store } from "../../../../redux/configStore";
import { checkOTP, generaOTP } from "../../../../api/User/editUser";
import OTPModal from "../../../User/OTPModal";
import { getListVoucherDetail } from "../../../../api/customer/redeemvoucher/redeemVoucher";
import useStoreData from "../../../../hooks/useStoreData";
import { brand } from "../../../../theme/tokens";

export default function RedeemDiscountCustomer() {
  const [form] = Form.useForm();
  const { voucherOfCustomer, isLoading } = useSelector(
    (state) => state.persistedReducer.redeemDisCountCustomer
  );
  const { data: allListStore, loading: isLoadStoreAll } = useStoreData();
  const dataTree = transformData(allListStore?.data);
  const options = dataTree?.filter((item) => item.parent_id === 0);
  const [isLoadingSearch, setIsLoadingSearch] = useState();
  const [isLoadExchange, setIsLoadExchange] = useState({});
  const [data, setData] = useState([]);
  const { id } = useParams();
  useEffect(() => {
    const fetchData = async () => {
      await store.dispatch(getListVoucherDetail(id));
    };
    fetchData();
  }, [id]);

  useEffect(() => {
    const dataNew = voucherOfCustomer?.data?.coupon_code_map.map(
      (items, index) => {
        return {
          key: index + 1,
          code_id: items.code_id,
          code: items?.code?.code,
          image: items?.code?.image,
          preferential_type: items?.code?.preferential_type,
          preferential_value: items.code?.preferential_value?.toLocaleString(),
          timeuse: items?.code?.end_date,
          branch: items.code?.branch.name,
          date_use: items.date_use,
          campaign: items.code?.campaign,
          branchs: items.code?.branch,
          exchange_point: items.code?.exchange_point,
          maximum_reduction: items.code?.maximum_reduction,
          minimum_value: items.code?.minimum_value,
          quantity: items.code?.quantity,
          number_use: items.code?.number_use,
          status: items.status,
        };
      }
    );
    setData(dataNew);
  }, [voucherOfCustomer]);
  const [formOTP] = Form.useForm();
  const [otpModalVisible, setOtpModalVisible] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const [phoneCustomer, setPhoneCustomer] = useState();
  useEffect(() => {
    let timer;
    if (countdown > 0 && otpModalVisible) {
      timer = setTimeout(() => setCountdown(countdown - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [countdown, otpModalVisible]);

  const [selectedStore, setSelectedStore] = useState();
  const handleSearch = useCallback(async () => {
    setIsLoadingSearch(true);
    if (selectedStore !== undefined) {
      const { value } = selectedStore;
      try {
        const response = await store.dispatch(
          getPointCustomerSee({
            value,
            customer_id: voucherOfCustomer?.data?.id,
          })
        );
        const newPoint = response.payload.data;
        Modal.info({
          title: "Số điểm của khách:",
          content: (
            <>
              <p style={{ color: brand.accent, fontWeight: 400, fontSize: 18 }}>
                {newPoint} điểm
              </p>
              <p>
                Tại đơn vị <b>{selectedStore?.label[0]}</b>
              </p>
            </>
          ),
        });
        setIsLoadingSearch(false);
      } catch (error) {
        setIsLoadingSearch(false);
        // Xử lý lỗi nếu có
      }
    } else {
      setIsLoadingSearch(false);
      message.error("Bạn chưa chọn đơn vị !");
    }
  }, [selectedStore, setIsLoadingSearch, voucherOfCustomer]);
  const handleExchangePoint = useCallback(
    async (value) => {
      const data = {
        branch_id:
          value.branchs?.children.length === 0
            ? value.branchs.id
            : selectedStore.value,
        code_id: value.code_id,
        customer_id: voucherOfCustomer?.data?.id,
      };
      try {
        if (data.branch_id !== undefined) {
          const response = await store.dispatch(exchangePoint(data));
          if (response.payload.data === true) {
            message.success("Đổi mã thành công");
            setSelectedStore(null);
            await store.dispatch(getListVoucherDetail(id));
          } else {
            message.error(response.payload.data.original.message);
          }
        } else {
        }
      } catch (error) {
        message.error("Có lỗi xảy ra");
      }
    },
    [selectedStore, id, voucherOfCustomer]
  );

  const [selectRecord, setSelectRecord] = useState();
  const generaeOtp = useCallback(
    async (values) => {
      setIsLoadExchange((preLoading) => ({
        ...preLoading,
        [values.code_id]: true,
      }));
      const data = {
        phone: voucherOfCustomer?.data?.phone,
        action:"change-coupon",
        code_id:values.code_id
      };
      // Kiểm tra xem người dùng đã chọn đơn vị chưa
      if (
        selectedStore?.value === undefined &&
        values?.branchs?.children.length > 0
      ) {
        message.error("Vui lòng chọn đơn vị bạn muốn sử dụng mã");
        setIsLoadExchange((preLoading) => ({
          ...preLoading,
          [values.code_id]: false,
        }));
        return; // Kết thúc hàm nếu chưa chọn đơn vị
      }
      try {
        const response = await generaOTP(data);
        if (response?.status === true) {
          setIsLoadExchange((preLoading) => ({
            ...preLoading,
            [values.code_id]: false,
          }));
          setSelectRecord(values);
          setOtpModalVisible(true);
          setPhoneCustomer(data.phone);
          setCountdown(60);
          message.success("Đã gửi mã OTP");
        } else {
          setIsLoadExchange((preLoading) => ({
            ...preLoading,
            [values.code_id]: false,
          }));
          setOtpModalVisible(false);
          // message.error("Đã vượt quá số lần thử vui lòng thử lại sau 3 phút");
          message.error(response.payload.original.error);
        }
      } catch (error) {
        setIsLoadExchange((preLoading) => ({
          ...preLoading,
          [values.code_id]: false,
        }));
        setOtpModalVisible(false);
        message.error("Có lỗi xảy ra");
      }
    },
    [selectedStore, setOtpModalVisible, setCountdown, voucherOfCustomer]
  );
  const handleOtpSubmit = useCallback(
    async (values) => {
      const result = values.otp.join("");
      const data = {
        phone: phoneCustomer,
        token: result,
        action:"change-coupon",
        code_id:selectRecord?.code_id
      };
      try {
        const response = await checkOTP(data);
        if (response?.status === true) {
          setOtpModalVisible(false);
          formOTP.resetFields();
          await handleExchangePoint(selectRecord);
          // message.success("Đã xác minh vui lòng cập nhật");
        } else if (response?.message === "OTP does not match") {
          message.error("Mã OTP không khớp");
        } else if (response?.message === "OTP is expired") {
          message.error("Mã OTP đã hết hạn");
        } else {
          message.error("Đã vượt quá số lần thử vui lòng thử lại sau 3 phút");
        }
      } catch (error) {
        message.error("Có lỗi xảy ra");
      }
    },
    [
      formOTP,
      setOtpModalVisible,
      phoneCustomer,
      handleExchangePoint,
      selectRecord,
    ]
  );
  const [checkPoint, setCheckPoint] = useState();
  const handleTreeSelectChange = useCallback(
    async (value, label) => {
      setSelectedStore({ value, label });
      const response = await store.dispatch(
        getPointCustomerSee({
          value,
          customer_id: voucherOfCustomer?.data?.id,
        })
      );
      setCheckPoint(response?.payload?.data);
    },
    [setSelectedStore, voucherOfCustomer]
  );
  const columns = [
    {
      title: "Tên mã",
      dataIndex: "code",
      width: "16%",
      render: (text, record) => {
        const userAvatar = record?.image ? resolveImageUrl(record.image) : null;
        const content = (
          <>
            <p>
              Số điểm cần đổi:{" "}
              <b style={{ color: brand.accent }}>{record.exchange_point}</b>{" "}
            </p>
            <p>
              Giá trị ưu đãi:{" "}
              <b style={{ color: brand.accent }}>
                {record.preferential_value?.toLocaleString()}
              </b>{" "}
              {record.preferential_type === "MONEY" ? "VNĐ" : "%"}
            </p>
            {record.preferential_type === "MONEY" ? (
              <p>
                Áp dụng cho đơn hàng tối thiểu:
                <b style={{ color: brand.accent }}>
                  {" "}
                  {record.minimum_value?.toLocaleString()}
                </b>{" "}
                VNĐ
              </p>
            ) : (
              <p>
                Giảm tối đa:{" "}
                <b style={{ color: brand.accent }}>
                  {record.maximum_reduction?.toLocaleString()}
                </b>{" "}
                VNĐ
              </p>
            )}
          </>
        );
        return (
          <Flex align="center">
            <Avatar
              shape="square"
              style={{ cursor: "pointer", marginRight: "12px" }}
              size={50}
              src={userAvatar}
              icon={record?.image ? null : <GiftOutlined />}
            />
            <Popover
              content={content}
              title="Chi tiết mã giảm giá"
              trigger="click"
            >
              <Button type="link">{text}</Button>
            </Popover>
          </Flex>
        );
      },
    },
    {
      title: "Thời gian",
      dataIndex: "timeuse",
      width: "16%",
      render: (_, record) => {
        const currentDate = new Date();
        const endDate = record?.timeuse;
        const formattedTimeDifference = calculateTimeDifference(
          currentDate,
          endDate
        );
        const dateUse = new Date(record.date_use);
        const formattedDate = `${dateUse.getDate()}/${
          dateUse.getMonth() + 1
        }/${dateUse.getFullYear()}`;
        if (parseInt(formattedTimeDifference) < 0) {
          return <Badge status="error" text="Đã hết hạn" />;
        } else {
          return record.status === "USED"
            ? `Đã sử dụng ngày ${formattedDate}`
            : formattedTimeDifference;
        }
      },
    },
    {
      title: "Trạng thái",
      dataIndex: "status",
      width: "16%",
      render: (_, record) =>
        record.status === "CAN_USE" ? (
          <Badge status="processing" text="Có thể đổi" />
        ) : record.status === "UN_USED" ? (
          <Badge status="success" text="Chưa sử dụng" />
        ) : (
          <Badge status="error" text="Đã sử dụng" />
        ),
    },
    {
      title: "Áp dụng cho đơn vị và chi nhánh",
      dataIndex: "branch",
      width: "16%",
      render: (_, record) =>
        record?.branchs?.children?.length === 0 ? (
          <Button style={{ padding: 0, color: brand.accent }} disabled type="text">
            {record.branch}
          </Button>
        ) : (
          <span>
            {" "}
            Chuỗi đơn vị <Typography.Link>{record?.branch}</Typography.Link>
          </span>
        ),
    },

    {
      title: "Số điểm cần đổi",
      dataIndex: "exchange_point",
      width: "16%",
    },
    {
      title: "Thao tác",
      dataIndex: "operation",
      align: "center",
      width: "16%",
      render: (_, record) => {
        const currentDate = new Date();
        const endDate = record?.timeuse;
        const formattedTimeDifference = calculateTimeDifference(
          currentDate,
          endDate
        );
        return (
          <>
            {false ? (
              <Button
                style={{
                  padding: "9px 36px",
                  height: "auto",
                  fontSize: "16px",
                  fontWeight: "500",
                  width: "100%",
                }}
                onClick={() => {
                  handleExchangePoint(record);
                }}
                type="primary"
                htmlType="submit"
                className="login-form-button"
              >
                Xác nhận
              </Button>
            ) : (
              <Button
                style={{
                  padding: "9px 36px",
                  height: "auto",
                  fontSize: "16px",
                  fontWeight: "500",
                  width: "100%",
                }}
                onClick={() => {
                  generaeOtp(record);
                }}
                icon={<SwapOutlined />}
                disabled={
                  // (record.branchs?.children.length === 0 &&
                  //   record.branchs.customer_stores?.point <
                  //     record.exchange_point) ||
                  record.status !== "CAN_USE" ||
                  parseInt(formattedTimeDifference) < 0 ||
                  record.quantity - record.number_use === 0 ||
                  (record.branchs?.children.length !== 0 &&
                    selectedStore?.value !== undefined &&
                    selectedStore?.value !== record.branchs.id &&
                    (!record.branchs?.children ||
                      !record.branchs?.children.some(
                        (child) => child.id === selectedStore?.value
                      ))) ||
                  (record.branchs?.children.length !== 0 &&
                    checkPoint < record.exchange_point)
                }
                loading={isLoadExchange[record.code_id]}
                type="primary"
              >
                Đổi mã
              </Button>
            )}
          </>
        );
      },
    },
  ];

  return (
    <div>
      <Breadcrumb separator=">">
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>Khách hàng</Breadcrumb.Item>
        <Breadcrumb.Item>
          <NavLink to="/exchange-vouchers">Đổi mã cho khách hàng</NavLink>
        </Breadcrumb.Item>
      </Breadcrumb>

      <Row gutter={[16, 16]}>
        <Col xl lg md sm>
          <TreeSelect
            style={{ width: 300, marginBottom: 20 }}
            disabled={isLoadStoreAll}
            allowClear
            placeholder="Tra cứu và đổi mã "
            showSearch
            filterTreeNode={(inputValue, treeNode) => {
              return treeNode.title
                .toLowerCase()
                .includes(inputValue.toLowerCase());
            }}
            value={selectedStore}
            onChange={handleTreeSelectChange}
            treeLine
            onClear={() => setSelectedStore(undefined)}
            treeData={options}
          />
        </Col>
        <Col xl lg md sm>
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleSearch}
            loading={isLoadingSearch}
          >
            Tra cứu
          </Button>
        </Col>
      </Row>
      {/* <Form form={form} component={false}>
        <Table
          columns={columns}
          pagination={{
            showTotal: (total, range) =>
              `Hiển thị từ ${range[0]} -> ${range[1]} trong tổng ${total} giá trị`,
            showQuickJumper: true,
            showSizeChanger: true,
            // onShowSizeChange: handleSizeChange,
            // total: listCustomerSee?.total,
            // current: currentPage,
            // onChange: handlePageChange,
          }}
          loading={data?.length === 0 ? isLoading : false}
          dataSource={isLoading ? [] : data}
          locale={{
            emptyText: isLoading ? (
              <Flex vertical gap={20}>
                {[...Array(data?.length || 0)].map((_, rowIndex) => (
                  <Flex gap={10} key={rowIndex}>
                    {columns.map((column) => (
                      <Skeleton.Input
                        key={`${column.dataIndex}-${rowIndex}`}
                        active={true}
                        size="small"
                        style={{ width: "95%" }}
                      />
                    ))}
                  </Flex>
                ))}
              </Flex>
            ) : (
              <Empty />
            ),
          }}
          bordered
          scroll={{ x: 500}}
        />
      </Form>
      <OTPModal
        visible={otpModalVisible}
        onCancel={() => setOtpModalVisible(false)}
        handleOtpSubmit={handleOtpSubmit}
        generaeOtp={generaeOtp}
        countdown={countdown}
        formOTP={formOTP}
      /> */}
    </div>
  );
}
